function App() {
  return (
      // eslint-disable-next-line react/style-prop-object
      <div className="App">
          <h1>Develop push</h1>
          <h3>Martim SUper hotfixx</h3>
          <h3>Martin Super Hotfix 2 :D</h3>
          <h3>Hotfix DOC-170</h3>
          <h3>Other line... :8</h3>
      </div>
  );
}

export default App;

